import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveMarkets from "./components/LiveMarkets";
import Awards from "./components/Awards";
import HowItWorks from "./components/HowItWorks";
import WhyXPO from "./components/WhyXPO";
import WhatAreIndexes from "./components/WhatAreIndexes";
import HowIndexesWork from "./components/HowIndexesWork";
import IndexTypes from "./components/IndexTypes";
import About from "./components/About";
import Blog from "./components/Blog";
import MobileApp from "./components/MobileApp";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <Hero />
      <LiveMarkets />
      <Awards />
      <HowItWorks />
      <WhyXPO />
      <WhatAreIndexes />
      <HowIndexesWork />
      <IndexTypes />
      <About />
      <Blog />
      <MobileApp />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
